//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      currentIndex: 0,
      loading: false,
      ytApiTag: null,
      ytPlayer: null,
    };
  },
  props: {
    externalVideos: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    if (this.externalVideos == null) {
      this.$store.dispatch("getVideos", { page: 1, size: 10 });
    }
    //youtube api script
    this.$nextTick(() => {
      this.initiateYTapi();
      if (this.externalVideos != null) {
        setTimeout(() => {
          this.initiateYTPlayer(
            this.validateYoutubeURL(this.videoList[0].youtube_url)
          );
        }, 2000);
      }
    });
  },
  computed: {
    videoList() {
      if (this.externalVideos == null) {
        return this.$store.state.videos;
      } else {
        return this.externalVideos;
      }
    },
  },
  watch: {
    videoList() {
      setTimeout(() => {
        this.initiateYTPlayer(
          this.validateYoutubeURL(this.videoList[this.currentIndex].youtube_url)
        );
      }, 1000);
    },
  },
  methods: {
    validateYoutubeURL(url) {
      var p =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      var matches = url.match(p);
      if (matches) {
        return matches[1];
      }
      return false;
    },
    initiateYTapi() {
      if (this.ytApiTag == null) {
        this.ytApiTag = document.createElement("script");
        this.ytApiTag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(this.ytApiTag, firstScriptTag);
      }
    },
    updateVideo(id) {
      let currentYurl = this.validateYoutubeURL(id);
      this.ytPlayer.loadVideoById(currentYurl);
    },
    initiateYTPlayer(vId) {
      this.$refs.videolist.style.height =
        this.$refs.videoplayer.offsetHeight + "px";
      this.ytPlayer = new YT.Player("youtubeListPlayer", {
        height: "390",
        width: "640",
        videoId: vId,
        events: {
          onReady: this.onPlayerReady,
          //'onStateChange': onPlayerStateChange
        },
      });
    },
    onPlayerReady(event) {
      // event.target.playVideo();

      //this.lastVideo = index;
      setTimeout(() => {
        this.loading = false;
      }, 100);
    },
  },
};
